/** @format */

import React from "react";

const Founder = () => {
  return (
    <div className="about-founder content" id="founder">
      <h1>Message from the Founder</h1>
      <section className="text">
        I am pleased to welcome you to Soul4English, an organization to educate
        non-native English speakers about reading, writing, and speaking
        English. Coming to the United States in 2012, I've always had a passion
        for helping others and voicing my opinions about issues. I am the
        founder of Kak Atlantic, a newspaper company, and am part of the United
        Nations Immigrations Committee. I am also a community organizer in many
        other fields, a journalist, and a teacher who currently holds a master's
        degree in Peace & Conflict Studies from Dhaka University.
      </section>
    </div>
  );
};

export default Founder;
